import { AI_ACTION_LABELS, AI_PROVIDER_LABELS } from '../../config/aiProviders';
import { formatLocalDateTime } from '../../utils/formatTimestamp';

export function actionLabel(key) {
  return AI_ACTION_LABELS[key] || key || '—';
}

export function providerLabel(key) {
  return AI_PROVIDER_LABELS[key] || key || '—';
}

export function formatAiDate(value) {
  return formatLocalDateTime(value);
}

export function formatDuration(ms) {
  if (ms == null || ms === '') return '—';
  const n = Number(ms);
  if (Number.isNaN(n)) return '—';
  if (n < 1000) return `${n}ms`;
  if (n < 60_000) return `${(n / 1000).toFixed(1)}s`;
  return `${Math.floor(n / 60_000)}m ${Math.round((n % 60_000) / 1000)}s`;
}

export function formatTokens(n) {
  const v = Number(n) || 0;
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(2)}M`;
  if (v >= 1000) return `${(v / 1000).toFixed(1)}k`;
  return String(v);
}

export function statusClass(status) {
  if (status === 'completed') return 'success';
  if (status === 'running') return 'running';
  if (status === 'pending') return 'pending';
  if (status === 'failed') return 'danger';
  return 'muted';
}

export function parseUsageJson(raw) {
  if (!raw) return null;
  try {
    return typeof raw === 'string' ? JSON.parse(raw) : raw;
  } catch {
    return null;
  }
}
